import React from "react";
import { Keyboard } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const KeyboardShortcutsModal = ({ isOpen, onClose }) => (
  <Dialog open={isOpen} onOpenChange={onClose}>
    <DialogContent className="apple-card border-0 max-w-md">
      <DialogHeader>
        <DialogTitle className="apple-headline flex items-center gap-2">
          <Keyboard size={20} />
          Keyboard Shortcuts
        </DialogTitle>
      </DialogHeader>
      <div className="space-y-3 mt-4">
        {[
          { key: 'R', action: 'Refresh mood analysis' },
          { key: 'D', action: 'Toggle dark/light mode' },
          { key: 'S', action: 'Toggle ambient sound' },
          { key: 'H', action: 'Open mood history' },
          { key: 'C', action: 'Compare dates' },
          { key: 'I', action: 'Show help & about' },
          { key: '?', action: 'Show keyboard shortcuts' },
          { key: 'T', action: 'Start guided tour' },
        ].map(({ key, action }) => (
          <div key={key} className="flex justify-between items-center">
            <span style={{ color: 'var(--apple-text-secondary)' }}>{action}</span>
            <kbd className="keyboard-key">{key}</kbd>
          </div>
        ))}
      </div>
    </DialogContent>
  </Dialog>
);

export { KeyboardShortcutsModal };
